export default __webpack_public_path__ + "static/media/608.abecde11.jpg";